function TaskExecutedTick() {
  return <img className="executed" src="./svg/protocol-editor/execution-done.svg" alt="Executed" />;
}

export default TaskExecutedTick;
